import React from 'react';
import { Segment, List } from 'semantic-ui-react';

import { renderListItem } from '../../helper/notification-helper.js';

class NotificationUserList extends React.Component {

  render() {
    return (
      <Segment attached='bottom' loading={this.props.loading}>
        <List divided relaxed>
          <List.Item>
            <List.Icon name='github' size='large' verticalAlign='middle' />
            <List.Content>
              <List.Header as='a'>Semantic-Org/Semantic-UI-Meteor</List.Header>
              <List.Description as='a'>Updated 34 mins ago</List.Description>
            </List.Content>
          </List.Item>
        </List>
      </Segment>
    );
  }

}

export default NotificationUserList;



// WEBPACK FOOTER //
// ./src/components/protected/NotificationUserList.js